import { render, staticRenderFns } from "./ListOfPaymentFacilities.vue?vue&type=template&id=5731e52c&"
import script from "./ListOfPaymentFacilities.vue?vue&type=script&lang=js&"
export * from "./ListOfPaymentFacilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports